import React from "react";
import "./AboutUsText.scss";

export default function AboutUsText({ t }) {
  return <p className="about-us-text">{t("about_us_text")}</p>;
}
